export default __webpack_public_path__ + "static/media/Harbinger of Lamentation.e79e8541.jpg";